import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";

// Desktop-app bootstrap: if a seed token is passed in the URL fragment,
// stash it in localStorage and clear the fragment before React mounts.
// Fragment stays client-side (never sent to the server) so it's safe.
(() => {
  const m = window.location.hash.match(/[#&]mdtc_seed=([^&]+)/);
  if (m) {
    try { localStorage.setItem("midtc_token", decodeURIComponent(m[1])); } catch {}
    const cleanedHash = window.location.hash.replace(/[#&]?mdtc_seed=[^&]+/, "").replace(/^#$/, "");
    window.history.replaceState(null, "", window.location.pathname + window.location.search + cleanedHash);
  }
})();

// Apply the user's saved theme (brand + light/dark) before React mounts so
// there's no flash. Per-user; ThemeContext keeps it in sync afterward.
(() => {
  try {
    const mode = localStorage.getItem("midtc-theme");
    const brand = localStorage.getItem("midtc-brand");
    if (mode)  document.documentElement.setAttribute("data-theme", mode);
    if (brand) document.documentElement.setAttribute("data-brand-theme", brand);
  } catch {}
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
